import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store';

@Module({
  namespaced: true,
  name: 'objectCompletion',
  store,
  dynamic: true
})
class ObjectCompletionStoreModule extends VuexModule {
  public completedObjectIds: string[] = [];

  @Mutation
  public setObjectCompleted(objectId: string): void {
    if (!this.completedObjectIds.includes(objectId)) {
      this.completedObjectIds = [...this.completedObjectIds, objectId];
    }
  }
}

export default getModule(ObjectCompletionStoreModule);
